import { MouseEvent } from 'react';
import classNames from 'classnames';

import { icon_arrow_left, icon_arrow_right } from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';
import { ButtonVariantType } from '@gn-audio/jss-components';

import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

export interface ContentSliderProps {
  activeIndex: number;
  total: number;
  canScrollNext?: boolean;
  canScrollPrev?: boolean;
  hideIfCantScroll?: boolean;
  prevButtonClasses?: string;
  nextButtonClasses?: string;
  arrowsWrapperClass?: string;
  onNext: () => void;
  onPrev: () => void;
  buttonVariant?: ButtonVariantType;
}

const ArrowSliderNavigation = ({
  activeIndex,
  total,
  canScrollNext = true,
  canScrollPrev = true,
  hideIfCantScroll,
  prevButtonClasses,
  nextButtonClasses,
  arrowsWrapperClass,
  onNext,
  onPrev,
  buttonVariant = 'tertiary',
}: ContentSliderProps) => {
  const { t } = useFallbackTranslation();
  const goPrev = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onPrev && onPrev();
  };

  const goNext = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onNext && onNext();
  };

  return (
    <section className="overflow-hidden">
      <div
        className={classNames(
          'absolute top-0 z-30 flex justify-end px-6 py-12 md:px-16',
          arrowsWrapperClass
        )}
      >
        <Button
          variant={buttonVariant}
          className={classNames(prevButtonClasses, 'mr-4', {
            hidden: hideIfCantScroll && !canScrollPrev,
          })}
          size="l"
          disabled={!canScrollPrev || activeIndex === 0}
          aria-label={t('system.Previous')}
          icon={<JabraIcon Icon={icon_arrow_left} />}
          onClick={goPrev}
        />
        <Button
          className={classNames(nextButtonClasses, {
            hidden: hideIfCantScroll && !canScrollNext,
          })}
          variant={buttonVariant}
          size="l"
          disabled={!canScrollNext || activeIndex >= total - 1}
          aria-label={t('system.Next')}
          icon={<JabraIcon Icon={icon_arrow_right} />}
          onClick={goNext}
        />
      </div>
    </section>
  );
};

export default ArrowSliderNavigation;
